/** What kind of page this is; also the title while the session has none (or has not loaded). */
export const WORKSPACE_AGENT_ASSET_LIST_LABEL = 'Agent asset list';

export const getSaveAsBoardActionLabel = (savedTitle: string | null | undefined): string => {
  if (savedTitle == null) {
    return 'Save as board';
  }

  if (!savedTitle) {
    return 'Saved as board';
  }

  return `Saved as ${savedTitle}`;
};
